import React, { Component } from 'react';
import "../CSS/fonts/OpenSans-Bold.eot";
import "../CSS/fonts/OpenSans-Bold.ttf";
import "../CSS/fonts/OpenSans-Regular.eot";
import "../CSS/fonts/OpenSans-Regular.ttf";
import "../CSS/fonts/OpenSans-Semibold.eot";
import "../CSS/fonts/OpenSans-Semibold.ttf";
import "../CSS/CustomStyles.css";
import { Popup, ConfirmationPopupContent, NewFileTypePopupContent, VersionPreviewPopupContent } from "./Popup";
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import DatePicker from "react-datepicker";
import { convertDateToUTC } from "../scripts/ResourceManager.js";
import "react-datepicker/dist/react-datepicker.css";
import "../CSS/Draft-js.css";
import SectionHeader from "./SectionHeader";
import moment from "moment";

class FileRow extends Component {
    constructor(props) {
        super(props);
        this.onFileAdded = this.onFileAdded.bind(this);
    }

    RemoveFile() {
        let fupCtrl = document.getElementById("fileUpload_" + this.props.fileIndex);
        fupCtrl.value = "";
        this.props.onDataChange(fupCtrl);
    }

    onFileAdded(control) {
        if (control.files.length <= 0) {
            return;
        }

        const currentVersionFileNames = this.props.versionData.downloadFileInfo.map((item) => item.fileName);
        const duplicateIndex = currentVersionFileNames.indexOf(control.files[0].name);

        if (duplicateIndex > -1) {
            control.value = "";
            alert("file name already used");
            return;
        }

        for (var i = 0; i < this.props.allVersionData.length; i++) {
            const version = this.props.allVersionData[i];
            if (this.props.versionData.id == version.id) {
                continue;
            }
            for (var j = 0; j < version.downloadFileInfo.length; j++) {
                const fileName = version.downloadFileInfo[j].fileName;
                if (fileName == control.files[0].name) {
                    control.value = "";
                    alert("file name already used");
                    return;
                }
            }
        }

        this.props.onDataChange(control);
    }

    render() {
        const { fileInfo, fileIndex } = this.props;
        const removeFileClassNames = fileInfo.fileName.length > 0 ? "CA-clearFile" : "CA-clearFile collapse";
        const typeName = fileInfo.fileTypeName + (fileInfo.fileTypeName == "Excel add-in" || fileInfo.fileTypeName == "Leaf application" ? "<span class='requiredField'> *</span>" : "");
        const englishLabel = "Text to display in English for " + (fileInfo.fileTypeName) + (fileInfo.fileTypeName == "Excel add-in" || fileInfo.fileTypeName == "Leaf application" ? "<span class='requiredField'> *</span>" : "");
        const frenchLabel = "Text to display in French for " + (fileInfo.fileTypeName) + (fileInfo.fileTypeName == "Excel add-in" || fileInfo.fileTypeName == "Leaf application" ? "<span class='requiredField'> *</span>" : "");
        return (
            <div className={"row col-12 mx-0 px-0 pt-4"} key={fileIndex} >
                <div className={"form-group col-lg-6 col-s-12 col-6 pl-0 pr-4"}>
                    <label dangerouslySetInnerHTML={{ __html: typeName }} htmlFor={"fileUpload_" + fileIndex}></label>
                    <div className={"input-group CA-customFileType"}>
                        <span className={"input-group-btn"}>
                            <span className={"btn btn-file btn-default d-block p-0"}>
                                <span className={"form-control text-center border-0"}>{fileInfo.fileName.length > 0 ? fileInfo.fileName : "+ Add file"}</span>
                                <input className={"AddFilebtn"} type="file" id={"fileUpload_" + fileIndex} disabled={fileInfo.fileName.length > 0 ? true : false} onChange={(event) => this.onFileAdded(event.target)} bindkey={"downloadFileInfo.[" + fileIndex + "].fileName"} />
                            </span>
                        </span>
                        <span className={removeFileClassNames} onClick={this.RemoveFile.bind(this)}></span>
                    </div>
                </div>
                <div className={"col-6 px-0 col-6 col-s-12"}>
                    <div className={"col-12 px-0 pb-2 clearArea"}>
                        <label dangerouslySetInnerHTML={{ __html: englishLabel }} htmlFor={"CA-descp-English" + fileIndex}></label>
                        <input type="text" className={"form-control col-lg-8"} id={"CA-descp-English" + fileIndex} value={fileInfo.fileLinkDescriptionEN} bindkey={"downloadFileInfo.[" + fileIndex + "].fileLinkDescriptionEN"} onChange={(event) => this.props.onDataChange(event.target)} />
                    </div>
                    <div className={"col-12 px-0 pb-2 mt-2 clearArea"}>
                        <label dangerouslySetInnerHTML={{ __html: frenchLabel }} htmlFor={"CA-descp-French" + fileIndex}></label>
                        <input type="text" className={"form-control col-lg-8"} id={"CA-descp-French" + fileIndex} value={fileInfo.fileLinkDescriptionFR} bindkey={"downloadFileInfo.[" + fileIndex + "].fileLinkDescriptionFR"} onChange={(event) => this.props.onDataChange(event.target)} />
                    </div>
                </div>
            </div>
        );
    }
}

export default class VersionForm extends Component {
    constructor(props) {
        super(props);
        this.UpdateFormData = this.UpdateFormData.bind(this);
        this.UpdatePublishedDate = this.UpdatePublishedDate.bind(this);
        this.GetEditorState = this.GetEditorState.bind(this);
        this.onDescChange = this.onDescChange.bind(this);
        this.CloseDialog = this.CloseDialog.bind(this);
        this.ShowDialog = this.ShowDialog.bind(this);
        this.ShowNewFileTypeDialog = this.ShowNewFileTypeDialog.bind(this);
        this.AddFileType = this.AddFileType.bind(this);
        this.ShowPreview = this.ShowPreview.bind(this);
        this.SaveDraft = this.SaveDraft.bind(this);
        this.SavePublish = this.SavePublish.bind(this);
        this.Unpublish = this.Unpublish.bind(this);
        this.ShowPublishConfirmation = this.ShowPublishConfirmation.bind(this);
        this.ShowUnpublishConfirmation = this.ShowUnpublishConfirmation.bind(this);
        this.ValidateFields = this.ValidateFields.bind(this);
        this.GetEditorHtml = this.GetEditorHtml.bind(this);
        const editStateEN = this.GetEditorState("verionDescriptionEN", this.props.formData["verionDescriptionEN"]);
        const editStateFR = this.GetEditorState("verionDescriptionFR", this.props.formData["verionDescriptionFR"]);
        this.state = {
            formData: JSON.parse(JSON.stringify(this.props.formData)), originalData: JSON.parse(JSON.stringify(this.props.formData)), dialogKey: "", enEditorState: editStateEN, frEditorState: editStateFR
        };
    }

    ShowPreview() {
        let { formData } = this.state;
        formData["verionDescriptionEN"] = this.GetEditorHtml("verionDescriptionEN");
        formData["verionDescriptionFR"] = this.GetEditorHtml("verionDescriptionFR");
        this.setState({ dialogKey: "VersionPreview", formData: formData });
    }

    SaveDraft(event) {
        if (this.ValidateFields()) {
            alert("Please make sure to fill all the required(*) fields, also fill the corresponding english and french link text fields if a file is selected.");
            return;
        }
        event.target.disabled = true;
        document.getElementById("btnSavePublish").disabled = true;
        document.getElementById("btnSaveCancel").disabled = true;

        let { formData } = this.state;
        formData["verionDescriptionEN"] = this.GetEditorHtml("verionDescriptionEN");
        formData["verionDescriptionFR"] = this.GetEditorHtml("verionDescriptionFR");
        this.props.onSaveForm(formData, true);
        this.setState({ formData: formData });
    }

    SavePublish() {
        let { formData } = this.state;
        formData.published = true;
        formData["verionDescriptionEN"] = this.GetEditorHtml("verionDescriptionEN");
        formData["verionDescriptionFR"] = this.GetEditorHtml("verionDescriptionFR");
        this.props.onSaveForm(formData, true);
    }

    Unpublish() {
        //Only Unpublish no save
        let { originalData, formData } = this.state;
        originalData.published = false;
        this.props.onSaveForm(originalData, false);
        formData.published = false;
        this.setState({ dialogKey: "", formData: formData });
        //this.CloseDialog();
    }

    GetEditorState(editorKey, rawHtml) {
        const contentBlock = htmlToDraft(rawHtml);
        if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            return EditorState.createWithContent(contentState);
        }
        console.log("Editor state could not be retreived.");
        return null;
    }

    onDescChange(editorState, editorKey) {
        if (editorKey == "verionDescriptionEN") {
            this.setState({ enEditorState: editorState });
        }
        else {
            this.setState({ frEditorState: editorState });
        }
    }

    GetEditorHtml(editorKey) {
        if (editorKey == "verionDescriptionEN") {
            return draftToHtml(convertToRaw(this.state.enEditorState.getCurrentContent()));
        }
        else {
            return draftToHtml(convertToRaw(this.state.frEditorState.getCurrentContent()));
        }
    }

    UpdatePublishedDate(date) {
        let { formData } = this.state;
        let newDate = date === null ? new Date() : date;
        formData.publishedDate = moment(newDate).format('YYYY-MM-DD');//convertDateToUTC(newDate).getTime();
        this.setState({ formData: formData });
    }

    UpdateFormData(control) {
        var newFormData = this.state.formData;
        var newObj = newFormData;
        var updateKey = control.getAttribute("bindkey");
        var keys = updateKey.split(".");
        if (keys.length > 1) {
            updateKey = keys[keys.length - 1];
            for (var i = 0; i < keys.length; i++) {

                if (keys[i].indexOf('[') == 0 && keys[i].indexOf(']') == (keys[i].length - 1)) {
                    var valueArrayIndex = keys[i].replace("[", "").replace("]", "");
                    valueArrayIndex = parseInt(valueArrayIndex);
                    newObj = newObj[valueArrayIndex];
                    continue;
                }

                if (keys[i] != updateKey) {
                    newObj = newObj[keys[i]];
                }
            }
        }

        newObj[updateKey] = control.type == "file" ? (control.files.length > 0 ? control.files[0].name : "") : control.value;
        this.setState({ formData: newFormData });
    }

    ValidateFields() {
        const { formData } = this.state;
        var returnVal = !formData.version || !formData.downloadFileInfo[0].fileName || !formData.downloadFileInfo[0].fileLinkDescriptionEN || !formData.downloadFileInfo[0].fileLinkDescriptionFR || !formData.downloadFileInfo[1].fileName || !formData.downloadFileInfo[1].fileLinkDescriptionEN || !formData.downloadFileInfo[1].fileLinkDescriptionFR;
        returnVal = returnVal || (formData.downloadFileInfo.map((download) => (download.fileName != "" && (download.fileLinkDescriptionEN == "" || download.fileLinkDescriptionFR == "")) ? true : false)).indexOf(true) > -1 ? true : false;
        return returnVal;
    }

    CloseDialog() {
        this.setState({ dialogKey: "" });
    }

    ShowNewFileTypeDialog() {
        this.setState({ dialogKey: "AddNewFileType" });
    }


    AddFileType(fileTypeInfo) {
        let { formData } = this.state;
        formData.downloadFileInfo.push(fileTypeInfo);
        this.setState({ formData: formData, dialogKey: "" });
        //this.CloseDialog();
    }

    ShowDialog() {
        switch (this.state.dialogKey) {
            case "AddNewFileType": {
                return (<Popup dialogKey="AddNewFileType" classNames="" dialogTitle="Add New File Type" onClose={this.CloseDialog}><NewFileTypePopupContent AddFileType={typeInfo => this.AddFileType(typeInfo)} CloseDialog={this.CloseDialog} /></Popup>);
            }

            case "VersionPreview": {
                const { formData } = this.state;
                const { mobileData } = this.props;
                return (<Popup dialogKey="VersionPreview" classNames="modal-dialog modal-lg" dialogTitle={"Preview of \"" + formData.version + "\""} onClose={this.CloseDialog}><VersionPreviewPopupContent onPublish={this.SavePublish} CloseDialog={this.CloseDialog} data={[formData]} mobileData={mobileData} showActions={false} /></Popup>);
            }

            case "PublishPreview": {
                const { formData } = this.state;
                const { mobileData } = this.props;
                return (<Popup dialogKey="PublishPreview" classNames="modal-dialog modal-lg" dialogTitle={"Are you sure you want to publish version \"" + formData.version + "\"?"} onClose={this.CloseDialog}><VersionPreviewPopupContent onPublish={this.SavePublish} CloseDialog={this.CloseDialog} data={[formData]} mobileData={mobileData} showActions={true} /></Popup>);
            }

            case "UnpublishConfirm": {
                const { version } = this.state.formData;
                var title = "Confirmation to unpublish \"" + version + "\"";
                return (<Popup dialogKey="UnpublishConfirm" dialogTitle={title} classNames="" onClose={this.CloseDialog}><ConfirmationPopupContent message="Are you sure you want to unpublish?" okButtonText="Unpublish" onCancel={this.CloseDialog} onOk={this.Unpublish} /></Popup>);
            }
        }
        return null;
    }

    ShowPublishConfirmation() {
        if (this.ValidateFields()) {
            alert("Please make sure to fill all the required(*) fields, also fill the corresponding english and french link text fields if a file is selected.");
            return;
        }
        let { formData } = this.state;
        formData["verionDescriptionEN"] = this.GetEditorHtml("verionDescriptionEN");
        formData["verionDescriptionFR"] = this.GetEditorHtml("verionDescriptionFR");
        this.setState({ dialogKey: "PublishPreview", formData: formData });
    }

    ShowUnpublishConfirmation() {
        this.setState({ dialogKey: "UnpublishConfirm" });
    }


    ValidatePublishedDate(e) {
        const len = e.target.value.length;        
        if (e.which == 46 ||
            e.which == 8 ||
            e.which == 27 ||
            e.which == 9) {
            return;
        }

        if (len == 10) {
            e.preventDefault();
        }

        if (e.shiftKey || e.ctrlKey || e.altKey) {
            e.preventDefault();
        }

        if ([0, 1, 2, 3, 5, 6, 8, 9].indexOf(len) > -1 && [48, 49, 50, 51, 52, 53, 54, 55, 56, 57].indexOf(e.which) == -1) {
            e.preventDefault();
        }
        else if ((len == 4 || len == 7) && e.which != 189) {
            e.preventDefault();
        }
    }

    render() {
        const { formData, originalData, enEditorState, frEditorState } = this.state;
        const dialog = this.ShowDialog();
        const selectedPublishedDate = formData.publishedDate === "" ? null : moment(formData.publishedDate, "YYYY-MM-DD").toDate();//moment.utc(formData.publishedDate).toDate();
        return (
            <div className={"CA-Dashboard col-12 p-3 px-5 mb-2"}>
                <SectionHeader>
                    <span className={"col-4 px-0 CA-title pl-1"}>{originalData.version != "" ? originalData.version : "CleverAnt Version"}<span className={"CA-VersionState m-1 d-inline-block ml-3"}>{formData.published ? "Published" : "Draft"}</span>
                    </span>
                    <span className={"col-8 px-0 pull-right text-right"}>
                        <a href="javascript:void(0)" className={"CA-hyperlink1 pr-1"} onClick={this.ShowPreview}>Preview</a>
                    </span>
                </SectionHeader>
                <div className={"CA-AdminForm row col-12 px-0 mx-0 bg-white p-3"}>
                    <span className={"CA-SectionHeading d-block col-12 px-0 pb-1"}>Version Details</span><form action="" className={"row col-12 px-0 mx-0"}>
                        <div className={"row col-12 mx-0 px-0  pt-4"}>
                            <div className={"form-group col-lg-6 col-s-12 col-6 pl-0 pr-4"}>
                                <label htmlFor="CA-Version">CleverAnt Version <span className='requiredField'>*</span></label>
                                <input type="text" className={"form-control col-lg-8"} id="CA-Version" name="CleverAnt Version"
                                    value={formData.version} bindkey="version" onChange={(event) => this.UpdateFormData(event.target)} />
                            </div>
                            <div className={"form-group col-lg-6 col-s-12 col-6 pr-0"}>
                                <label htmlFor="dtPicker">Release Date<span className={"sub"}> (YYYY-MM-DD)</span></label>
                                <DatePicker className={"form-control"} dateFormat="yyyy-MM-dd" selected={selectedPublishedDate} onChange={this.UpdatePublishedDate} autoComplete="off" onKeyDown={(event) => this.ValidatePublishedDate(event)} id="dtPicker" />
                                <a href="javascript:void(0)" onClick={() => {
                                    document.getElementById('dtPicker').focus();
                                }}><span className="dtPicker"><span class="sr-only">Date picker</span></span></a>
                            </div>
                        </div>
                        <div className={"row col-12 mx-0 px-0 pt-3"}>
                            <div className={"form-group col-lg-6 col-s-12 col-6 pl-0 pr-4"}>
                                <label htmlFor="CA-descp-Eng">Description in English</label>
                                <Editor id="CA-descp-Eng" editorState={enEditorState} wrapperClassName="demo-wrapper" editorClassName="demo-editor" onEditorStateChange={(editState) => this.onDescChange(editState, "verionDescriptionEN")}
                                />
                            </div>
                            <div className={"form-group col-lg-6 col-s-12 col-6 pr-0"}>
                                <label htmlFor="CA-descp-French">Description in French</label>
                                <Editor id="CA-descp-French" className={"form-control"} editorState={frEditorState} wrapperClassName="demo-wrapper" editorClassName="demo-editor" onEditorStateChange={(frEditState) => this.onDescChange(frEditState, "verionDescriptionFR")}
                                />
                            </div>
                        </div>
                        <div className={"col-6 mx-auto pt-2 CA-horizotalbar"}></div>
                        <div className={"CA-newFileType col-12 px-0 pt-2"}>
                            <div className={"row col-12 px-0 mx-0"}>
                                <span className={"CA-SectionHeading d-block col-8 px-0 pb-1 border-0"}>Files</span>
                                <span className={" col-4 pull-right text-right pr-0"}>
                                    <button className={"btn link-btn CA-AddNewFileType"} type="button" onClick={this.ShowNewFileTypeDialog}>Add new file type</button>
                                </span>
                            </div>
                            {formData.downloadFileInfo.map((fi, index) => <FileRow fileInfo={fi} fileIndex={index} onDataChange={(control) => this.UpdateFormData(control)} key={index} allVersionData={this.props.allVersionData} versionData={formData} />)}
                        </div>
                    </form>
                </div>
                <div className={"CA-buttonSection row col-12 justify-content-center mx-0"}>
                    <div className={"row col-12 px-0 mx-0 mx-auto p-4  pb-0 justify-content-center"}>
                        <span className={"mr-2 d-inline-block"}>
                            <button id="btnSaveCancel" className={"CTA-Cancel  btn"} onClick={() => this.props.onCancel(originalData)}>Cancel</button>
                        </span>{formData.published ? <div><span className={"mr-2 d-inline-block"}>
                            <button className={"CTA-active border-0 btn"} onClick={this.ShowUnpublishConfirmation}>Unpublish</button>
                        </span><span className={"mr-2 d-inline-block"}>
                                <button className={"CTA-active border-0 btn"} onClick={this.ShowPublishConfirmation}>Save &amp; Publish</button>
                            </span></div> : <div><span className={"mr-2 d-inline-block"}>
                                <button id="btnSaveDraft" className={"CTA-active border-0 btn"} onClick={this.SaveDraft}>Save as draft</button>
                            </span><span className={"mr-2 d-inline-block"}>
                                    <button id="btnSavePublish" className={"CTA-active border-0 btn"} onClick={this.ShowPublishConfirmation}>Save &amp; Publish</button>
                                </span>
                            </div>
                        }
                    </div>
                </div>
                {dialog}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/VersionForm.js